/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Add } from "@material-ui/icons";
import {
  Dialog,
  DialogTitle,
  FormControl,
  Button,
  makeStyles,
  MenuItem,
  DialogActions,
  FormHelperText,
  DialogContent,
  TextField,
  CircularProgress,
  Snackbar
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import useEffectAsync from "lib/react/customHooks";
import useFormFields from "lib/forms";
import {
  publishEventCreateAthenaTenant,
  getAthenaTenants
} from "lib/services/athenaTenants";
import { getCompanies } from "lib/services/companies";
import { filter as _filter } from "lodash";

const useStyles = makeStyles(theme => ({
  addUserButton: {
    backgroundColor: "#90cb7c"
  },
  button: {
    margin: theme.spacing(1)
  },
  fieldHelperText: {
    fontSize: "smaller",
    color: "rgb(84, 84, 85)"
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

function Alert(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddAthenaTenantComponent({ onSuccess, athenaTenants }) {
  const classes = useStyles(() => ({
    dialogContent: {
      padding: "20px"
    }
  }));
  const [open, setOpen] = useState(false);
  const initialFields = {
    // mysql_user: "",
    // mysql_host: "",
    // mysql_port: "",
    // mysql_database: "",
    company_id: ""
  };
  const [fields, handleFieldChange, resetFields] = useFormFields(initialFields);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "",
    message: ""
  });

  const getAvailableCompanies = async () => {
    const [companiesResult, tenantsResult] = await Promise.all([
      getCompanies(),
      getAthenaTenants()
    ]);

    const tenantsObject = {};
    tenantsResult.data.forEach(tenant => {
      tenantsObject[tenant.company_id] = tenant;
    });

    return _filter(companiesResult.data, company => {
      return !tenantsObject[company.id];
    });
  };

  useEffectAsync(
    async () => {
      const availableCompanies = await getAvailableCompanies();
      return availableCompanies;
    },
    setCompanies,
    []
  );

  useEffect(() => {
    if (athenaTenants !== "undefined" && athenaTenants.length > 0) {
      const tenantsObject = {};
      athenaTenants.forEach(tenant => {
        tenantsObject[tenant.company_id] = tenant;
      });

      const companiesAvailable = _filter(companies, company => {
        return !tenantsObject[company.id];
      });
      setCompanies(companiesAvailable);
    }
  }, [athenaTenants]);

  const handleDialogOpen = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
    resetFields();
  };

  const handleFormSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const newSnackbarState = {
      open: true,
      severity: "success",
      message: "Tenant created successfully!"
    };

    try {
      await publishEventCreateAthenaTenant(fields.company_id);
      handleDialogClose();
      if (onSuccess && typeof onSuccess === "function") onSuccess();
    } catch (error) {
      if (error.response && error.response.statusText === "CONFLICT") {
        newSnackbarState.severity = "warning";
        newSnackbarState.message =
          "You're late! A tenant already exists for that company. Try using another company";
      } else {
        newSnackbarState.severity = "error";
        newSnackbarState.message =
          "An error occurred. Please try again shortly";
      }
    } finally {
      setLoading(false);
      setSnackbarState(newSnackbarState);
    }
  };

  const handleSnackbarClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarState(prevState => {
      return {
        ...prevState,
        open: false
      };
    });
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className={classes.button}
        startIcon={<Add />}
        onClick={handleDialogOpen}
      >
        New Tenant
      </Button>
      <Dialog
        className={classes.dialogContent}
        open={open}
        aria-labelledby="add-athena-tenant-form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="add-athena-tenant-form-dialog-title">
          Create new tenant
        </DialogTitle>
        <form onSubmit={handleFormSubmit}>
          <DialogContent>
            <FormControl fullWidth required className={classes.formControl}>
              <TextField
                value={fields.company_id}
                label="Company"
                onChange={handleFieldChange}
                name="company_id"
                select
                required
                fullWidth
              >
                {companies.map(company => {
                  return (
                    <MenuItem key={company.short_name} value={company.id}>
                      {company.short_name}
                    </MenuItem>
                  );
                })}
              </TextField>
              <FormHelperText className={classes.fieldHelperText}>
                This list only shows companies that DO NOT have an associated
                tenant
              </FormHelperText>
              {/* <TextField
                label="MySQL User"
                name="mysql_user"
                // value={fields.mysql_user || ""}
                // onChange={handleFieldChange}
                fullWidth
              />
              <FormHelperText className={classes.fieldHelperText}>
                If empty, it will take the company&apos;s shortname as value
              </FormHelperText>
              <TextField
                label="MySQL Hostname"
                name="mysql_host"
                value={fields.mysql_host}
                onChange={handleFieldChange}
                required
                fullWidth
              />
              <TextField
                label="MySQL Port Number"
                name="mysql_host"
                value={fields.mysql_port}
                onChange={handleFieldChange}
                fullWidth
              />
              <TextField
                label="MySQL Database"
                name="mysql_database"
                value={fields.mysql_database || ""}
                onChange={handleFieldChange}
                fullWidth
              />
              <FormHelperText className={classes.fieldHelperText}>
                If empty, it will take the company&apos;s shortname as value
              </FormHelperText> */}
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <div className={classes.wrapper}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                Create Tenant
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </DialogActions>
        </form>
      </Dialog>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarState.severity}>
          {snackbarState.message}
        </Alert>
      </Snackbar>
    </>
  );
}
